export default "__VITE_ASSET__BfygTAo0__"